import { FC, MouseEvent } from 'react';
import { Image, ImageFieldValue } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames';

import { IJabraTheme } from 'common/jabraTheme/JabraTheme.models';

export interface CircleLinkProps {
  image?: ImageFieldValue;
  title: string;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  theme: IJabraTheme;
}

const CircleLink: FC<CircleLinkProps> = ({ onClick, title, image, theme }) => {
  const circleBgColor = theme.darkTheme ? 'bg-gray-50' : 'bg-black/5';
  return (
    <button
      className="flex flex-col items-center justify-start p-6"
      aria-label={title}
      onClick={onClick}
    >
      <div
        className={classNames(
          circleBgColor,
          'mx-auto flex size-[88px] items-center rounded-full p-[1.44rem] md:size-[100px] md:p-[1.625rem] [&>img]:w-full'
        )}
      >
        <Image field={image} />
      </div>
      <span className="mt-6 block text-center text-base underline decoration-solid md:text-xl">
        {title}
      </span>
    </button>
  );
};

export default CircleLink;
